const _excluded = ["title", "disableArrow", "centerArrow"],
  _excluded2 = ["customArrow", "arrowInner", "centeredArrow"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState } from 'react';
import { Tooltip as MuiTooltip, Grow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import colors from "../../foundations/colors.module.scss";
import typography from "../../foundations/typography.module.scss";
import { PopoverArrowIcon } from "../PopoverArrowIcon";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const NoTransition = props => /*#__PURE__*/_jsx(Grow, _objectSpread(_objectSpread({}, props), {}, {
  timeout: 0
}));
const useStyles = makeStyles({
  tooltip: {
    fontFamily: typography.fontFamilyLight,
    fontSize: typography.fontSizeP1,
    color: colors.dark50,
    background: colors.dark900,
    padding: 12,
    borderRadius: 8,
    maxWidth: 'min(460px, 75vw)'
  },
  tooltipPlacementTop: {
    marginBottom: 12,
    '& $customArrow': {
      bottom: 4
    }
  },
  tooltipPlacementBottom: {
    marginTop: 12,
    '& $customArrow': {
      top: 4
    },
    '& $arrowInner': {
      transform: 'rotate(180deg)'
    }
  },
  tooltipPlacementLeft: {
    marginRight: 12,
    '& $customArrow': {
      right: -6
    },
    '& $arrowInner': {
      transform: 'rotate(270deg)'
    }
  },
  tooltipPlacementRight: {
    marginLeft: 12,
    '& $customArrow': {
      left: -6
    },
    '& $arrowInner': {
      transform: 'rotate(90deg)'
    }
  },
  customArrow: {
    position: 'absolute',
    width: 29,
    height: 9,
    color: colors.dark900
  },
  centeredArrow: {
    '& $customArrow': {
      left: '50% !important',
      transform: 'translateX(-50%)'
    }
  },
  arrowInner: {
    position: 'absolute'
  }
});
export function Tooltip(props) {
  const {
      title,
      disableArrow,
      centerArrow
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const [arrowRef, setArrowRef] = useState(null);
  const _useStyles = useStyles(),
    {
      customArrow,
      arrowInner,
      centeredArrow
    } = _useStyles,
    restStyles = _objectWithoutProperties(_useStyles, _excluded2);
  return /*#__PURE__*/_jsx(MuiTooltip, _objectSpread(_objectSpread({}, rest), {}, {
    arrow: false,
    enterTouchDelay: 0,
    leaveTouchDelay: 3000,
    title: title && /*#__PURE__*/_jsx("span", {
      "data-testid": rest['data-testid'],
      children: !disableArrow ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("span", {
          ref: setArrowRef,
          className: customArrow,
          children: /*#__PURE__*/_jsx(PopoverArrowIcon, {
            className: arrowInner
          })
        }), title]
      }) : title
    })
    // Necessary because our custom arrow appears with a delay when there's a transition.
    ,
    TransitionComponent: NoTransition,
    PopperProps: {
      popperOptions: {
        modifiers: {
          arrow: disableArrow ? undefined : {
            enabled: Boolean(arrowRef),
            element: arrowRef
          }
        }
      }
    },
    classes: _objectSpread(_objectSpread({}, restStyles), centerArrow && {
      tooltip: "".concat(restStyles.tooltip, " ").concat(centeredArrow)
    })
  }));
}